import { Heart, Building2, Mail, Phone } from "lucide-react";

export const DonateSection = () => {
  return (
    <section id="donate" className="py-20 bg-white" data-testid="donate-section">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2
            className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
            data-testid="donate-title"
          >
            Support Our Mission
          </h2>
          <div className="w-24 h-1 bg-amber-600 mx-auto mb-6"></div>
          <p
            className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto"
            style={{ fontFamily: "'Crimson Text', serif" }}
          >
            Your generous donations help us continue spreading the Gospel and serving communities
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* Main Donate Card */}
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-8 border border-gray-200">
            <div className="flex items-center justify-center mb-8">
              <div className="w-20 h-20 bg-amber-600 rounded-full flex items-center justify-center">
                <Heart className="text-white" size={40} />
              </div>
            </div>
            
            <h3
              className="text-3xl font-bold text-gray-900 text-center mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Make a Difference Today
            </h3>
            
            <p
              className="text-gray-700 text-center mb-8 leading-relaxed text-base max-w-2xl mx-auto"
              style={{ fontFamily: "'Crimson Text', serif" }}
            >
              As a non-profit organization, we rely on the generous support of believers like you to continue our ministry work. Your donations enable us to reach more souls, support community programs, and serve those in need.
            </p>

            {/* Donation Information */}
            <div className="bg-white rounded-xl p-8 mb-6">
              <h4
                className="text-2xl font-bold text-gray-900 mb-6 text-center"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                How to Donate
              </h4>
              
              <div className="space-y-6">
                <div className="border-l-4 border-amber-600 pl-6" data-testid="cash-donation-info">
                  <h5 className="font-bold text-gray-900 mb-2 text-lg" style={{ fontFamily: "'Playfair Display', serif" }}>
                    Cash Donations
                  </h5>
                  <p className="text-gray-700" style={{ fontFamily: "'Crimson Text', serif" }}>
                    Visit our office at the address below or during any of our service times to give your donation directly.
                  </p>
                </div>

                <div className="border-l-4 border-gray-600 pl-6" data-testid="contact-donation-info">
                  <h5 className="font-bold text-gray-900 mb-2 text-lg" style={{ fontFamily: "'Playfair Display', serif" }}>
                    Contact Us for Other Options
                  </h5>
                  <p className="text-gray-700 mb-3" style={{ fontFamily: "'Crimson Text', serif" }}>
                    For other donation methods or to discuss partnership opportunities, please contact us:
                  </p>
                  <div className="space-y-2">
                    <div className="flex items-center gap-2 text-gray-700">
                      <Mail size={18} className="text-amber-600" />
                      <span style={{ fontFamily: "'Crimson Text', serif" }}>contacts@bannerofgraceministry.org</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 border-2 border-gray-300 rounded-xl p-6 text-center">
              <p className="text-gray-700 text-sm" style={{ fontFamily: "'Crimson Text', serif" }}>
                <span className="font-bold">Tax Deductible:</span> All donations to our non-profit ministry are tax-deductible. We will provide receipts for your records.
              </p>
            </div>
          </div>

          {/* What Your Donation Supports */}
          <div className="bg-white rounded-xl shadow-lg p-8">
            <h4
              className="text-2xl font-bold text-gray-900 mb-6 text-center"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              What Your Donation Supports
            </h4>
            <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <Heart className="text-gray-700" size={24} />
                </div>
                <p className="text-gray-700 text-sm font-semibold">Community Outreach</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <Heart className="text-gray-700" size={24} />
                </div>
                <p className="text-gray-700 text-sm font-semibold">Youth Programs</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <Heart className="text-gray-700" size={24} />
                </div>
                <p className="text-gray-700 text-sm font-semibold">Mission Trips</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <Heart className="text-gray-700" size={24} />
                </div>
                <p className="text-gray-700 text-sm font-semibold">Charity Programs</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};